export enum ActivityActionCategory {
  Parere = 'parere',
  Firma = 'firma'
}
